// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Hungary from '../_raw/flag/icon_flag_hungary.png';

export default () => <img src={Hungary} alt="Hungary" />;
